/* Falconclaw chat widget v2 (Shopify theme asset fc-widget.js), built 2026-10-01.
 *
 * Look, wording and motion: widget/drafts/chat-box-draft-v2.html (approved).
 * Server: the WordPress relay at FC_CHAT.rest (falconclaw-chat/v1). Today that is relay 0.5:
 *   /start /message /poll /history /contact /feedback /verify/request /verify/confirm
 *   /restock/subscribe
 * Relay 0.6 (not live yet) adds /rate, /form and /feedback great|ok|poor. Which routes exist is
 * read ONCE per browser session from the namespace index (GET FC_CHAT.rest?fcw=<10 min bucket>, the
 * bare index is edge-cached for an hour), quietly, and cached
 * in sessionStorage. Missing route = today's behaviour; a 404 from a 0.6 route at runtime also
 * falls back. No error is ever shown for a missing route.
 *
 * ORDER_FLOW (below) is off. With it off, order questions go to Kai as normal messages and Kai
 * asks for email verification, exactly as today. With it on, the flow still only starts when the
 * relay announces /orders/request, /orders, /upload and /order-problem.
 *
 * Kept from the old widget: session resume (localStorage fc_chat_cid / fc_chat_tok), history,
 * read ticks, colleague messages and "X has joined the chat", end-rating eligibility timing,
 * product page context on /start, Crisp hiding, the Brevo newsletter post, the cable request
 * post to the Google Apps Script (feeds dispatch), and the ?nl= footer prefill at the end.
 * Root stays #fc-chat and the launcher stays #fc-chat-toggle: falconclaw-custom.css BLOCK 34 and
 * the "talk to us" buttons in product.fc-v2(.kit).json and page.about.json depend on them.
 */
( function () {
	'use strict';
	if ( typeof window.FC_CHAT === 'undefined' ) { return; }

	var CFG = window.FC_CHAT;
	var REST = String( CFG.rest || '' ).replace( /\/+$/, '' );
	var NONCE = CFG.nonce || '';
	var ON_SHOPIFY = CFG.source === 'shopify';
	var ORDER_FLOW = false;

	var PRIVACY_URL = ON_SHOPIFY ? '/policies/privacy-policy' : 'https://www.falconclaw.eu/privacy-policy/';
	// Same Google Apps Script as the PTT page cable form; dispatch drains its sheet hourly.
	var CABLE_SHEET_URL = 'https://script.google.com/macros/s/AKfycbxokHHZ4sM8JMyzjZFnF3urhcnhMpmli8Y3hkE2Hhta401wPypUsWy4vAKEWMic5oBdIw/exec';
	var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
	var POLL_MS = 2500;
	// PROGRESS-BAR v1 (Ivo 19.10.2026). CN-00154: GET /poll on the WordPress relay (Kinsta, no paid API behind it),
	// every PENDING_POLL_MS while a reply is pending (pendingSince set), else every POLL_MS, never faster.
	// Fast mode stops when the reply arrives, the send fails, a colleague owns the chat, or after TYPING_GRACE_MS.
	// Cost: a 15 s wait is about 15 polls instead of 6, so roughly 9 extra relay hits per customer message.
	var PENDING_POLL_MS = 1000;
	var TYPING_GRACE_MS = 60000;   // the progress bar stays this long after a send while waiting for Kai
	var FB_IDLE_MS = 180000, FB_CLOSE_MS = 6000;
	var FB_CLOSE_RE = /(\bthank(s| you| u)?\b|\bthx\b|\bty\b|\bcheers\b|\bappreciate|that'?s all|all good|that'?s it|no(thing)? else|\bperfect\b|\bgreat\b|\bawesome\b|\bbrilliant\b|ait[äa]h|t[äa]nan|kiitos|\bdanke\b|\bmerci\b|\bgracias\b|\bselge\b|\bsuper\b|got it|good to know|that help)/i;
	var PERSON_RE = /\b(person|human|colleague)\b/i;
	var STOCK_RE = /\b(stock|restock|back in|sold out|available|availability)\b/i;

	/* ---------- icons (SVG only) ---------- */
	var I = {
		send: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M22 2 11 13"/><path d="M22 2 15 22l-4-9-9-4z"/></svg>',
		x: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>',
		chat: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 12a8 8 0 0 1-11.6 7.1L4 20l1-4.6A8 8 0 1 1 21 12z"/></svg>',
		logo: '<svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M4 5l16 14M4 12l9 7M11 5l9 7M20 5 4 19"/></svg>',
		tick: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>',
		ok: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M8 12.5l3 3 5-6"/></svg>',
		clock: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>',
		alert: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3 2.5 20h19z"/><path d="M12 10v4M12 17.2v.1"/></svg>',
		box: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 8l9-5 9 5v8l-9 5-9-5z"/><path d="M3 8l9 5 9-5M12 13v8"/></svg>',
		truck: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 6h11v10H2zM13 9h4l4 4v3h-8z"/><circle cx="6.5" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/></svg>',
		swap: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 8h14l-3-3M20 16H6l3 3"/></svg>',
		undo: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M8 5 4 9l4 4"/><path d="M4 9h10a6 6 0 0 1 0 12h-3"/></svg>',
		edit: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 20h4L19 9l-4-4L4 16z"/><path d="M13.5 6.5l4 4"/></svg>',
		doc: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 3h9l4 4v14H6z"/><path d="M9 12h7M9 16h7M9 8h3"/></svg>',
		clip: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 11.5 12 19.5a5 5 0 0 1-7-7l8.5-8.5a3.3 3.3 0 0 1 4.7 4.7L9.8 17.1a1.7 1.7 0 0 1-2.4-2.4l7.6-7.6"/></svg>',
		up: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M7 11v9H4v-9zM7 11l4-8a2.5 2.5 0 0 1 2.5 2.5V9h5a2 2 0 0 1 2 2.4l-1.3 7A2 2 0 0 1 17.2 20H7"/></svg>',
		down: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" class="fcw-flip"><path d="M7 11v9H4v-9zM7 11l4-8a2.5 2.5 0 0 1 2.5 2.5V9h5a2 2 0 0 1 2 2.4l-1.3 7A2 2 0 0 1 17.2 20H7"/></svg>'
	};
	// End-of-chat faces: owner-made SVGs (widget/drafts/icons/face-*.svg), used verbatim.
	var FACE = {
		great: '<svg viewBox="0 0 52 41" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><circle cx="25.5" cy="20.5" r="20.5" fill="#84C87A"/><path d="M34 9C37.866 9 41 12.134 41 16C41 19.866 37.866 23 34 23C31.2078 23 28.7984 21.3647 27.6748 19H24.3252C23.2016 21.3647 20.7922 23 18 23C14.134 23 11 19.866 11 16C11 12.134 14.134 9 18 9C19.9069 9 21.635 9.76326 22.8975 11H29.1025C30.365 9.76326 32.0931 9 34 9Z" fill="black"/><rect x="9" y="12" width="14" height="8" fill="black"/><rect x="33" y="12" width="14" height="8" fill="black"/><circle cx="46" cy="16" r="6" fill="black"/><circle cx="6" cy="16" r="6" fill="black"/><circle cx="18" cy="16" r="4" fill="#94DC61"/><circle cx="16" cy="14" r="1" fill="#E7FFD4"/><circle cx="6" cy="16" r="4" fill="#94DC61"/><circle cx="4" cy="14" r="1" fill="#E7FFD4"/><circle cx="34" cy="16" r="4" fill="#94DC61"/><circle cx="46" cy="16" r="4" fill="#94DC61"/><circle cx="32" cy="14" r="1" fill="#E7FFD4"/><circle cx="44" cy="14" r="1" fill="#E7FFD4"/><path d="M17 29C24 32 28 32 35 29" stroke="black" stroke-width="2.5" stroke-linecap="round"/></svg>',
		ok: '<svg viewBox="0 0 52 41" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><circle cx="25.5" cy="20.5" r="20.5" fill="#E5BD69"/><path d="M34 9C37.866 9 41 12.134 41 16C41 19.866 37.866 23 34 23C31.2078 23 28.7984 21.3647 27.6748 19H24.3252C23.2016 21.3647 20.7922 23 18 23C14.134 23 11 19.866 11 16C11 12.134 14.134 9 18 9C19.9069 9 21.635 9.76326 22.8975 11H29.1025C30.365 9.76326 32.0931 9 34 9Z" fill="black"/><rect x="8" y="12" width="14" height="8" fill="black"/><rect x="33" y="12" width="14" height="8" fill="black"/><circle cx="46" cy="16" r="6" fill="black"/><circle cx="6" cy="16" r="6" fill="black"/><circle cx="18" cy="16" r="4" fill="#94DC61"/><circle cx="16" cy="14" r="1" fill="#E7FFD4"/><circle cx="6" cy="16" r="4" fill="#94DC61"/><circle cx="4" cy="14" r="1" fill="#E7FFD4"/><circle cx="34" cy="16" r="4" fill="#94DC61"/><circle cx="46" cy="16" r="4" fill="#94DC61"/><circle cx="32" cy="14" r="1" fill="#E7FFD4"/><circle cx="44" cy="14" r="1" fill="#E7FFD4"/><path d="M17 29C24 29 28 29 35 29" stroke="black" stroke-width="2.5" stroke-linecap="round"/></svg>',
		poor: '<svg viewBox="0 0 52 41" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><circle cx="25.5" cy="20.5" r="20.5" fill="#DF8573"/><path d="M34 9C37.866 9 41 12.134 41 16C41 19.866 37.866 23 34 23C31.2078 23 28.7984 21.3647 27.6748 19H24.3252C23.2016 21.3647 20.7922 23 18 23C14.134 23 11 19.866 11 16C11 12.134 14.134 9 18 9C19.9069 9 21.635 9.76326 22.8975 11H29.1025C30.365 9.76326 32.0931 9 34 9Z" fill="black"/><rect x="8" y="12" width="14" height="8" fill="black"/><rect x="33" y="12" width="14" height="8" fill="black"/><circle cx="46" cy="16" r="6" fill="black"/><circle cx="6" cy="16" r="6" fill="black"/><circle cx="18" cy="16" r="4" fill="#94DC61"/><circle cx="16" cy="14" r="1" fill="#E7FFD4"/><circle cx="6" cy="16" r="4" fill="#94DC61"/><circle cx="4" cy="14" r="1" fill="#E7FFD4"/><circle cx="34" cy="16" r="4" fill="#94DC61"/><circle cx="46" cy="16" r="4" fill="#94DC61"/><circle cx="32" cy="14" r="1" fill="#E7FFD4"/><circle cx="44" cy="14" r="1" fill="#E7FFD4"/><path d="M35 31.25C28 28.25 24 28.25 17 31.25" stroke="black" stroke-width="2.5" stroke-linecap="round"/></svg>'
	};

	/* ---------- state ---------- */
	var convId = null, custTok = null, afterId = 0, started = false, polling = false, pollStopped = false;
	var lastStatus = null, lastTick = null, typingEl = null, pendingSince = 0, agentName = '';
	var fbRated = false, botReplied = false, customerAsked = false, closingHint = false, fbTimer = null;
	var labelRun = null;           // who the last name label belongs to ("bot" or "agent:<name>")
	var startPromise = null;
	var caps = { rate: false, form: false, orders: false };
	var capsPromise = null;
	var S = { name: '', email: '', verified: false, hoSkipped: false, hoSent: false,
		askedStock: false, stockOffered: false, verifyNext: null, caseWait: null };

	/* ---------- Crisp: legacy client stays hidden ---------- */
	try {
		var stl = document.createElement( 'style' );
		stl.textContent = '.crisp-client,#crisp-chatbox,#crisp-chatbox a{display:none !important;}';
		document.head.appendChild( stl );
		var hc = setInterval( function () {
			try { if ( window.$crisp ) { window.$crisp.push( [ 'do', 'chat:hide' ] ); } } catch ( e ) {}
		}, 1000 );
		setTimeout( function () { clearInterval( hc ); }, 15000 );
	} catch ( e ) {}

	/* ---------- DOM ---------- */
	var root = document.createElement( 'div' );
	root.id = 'fc-chat';
	if ( ON_SHOPIFY ) { root.className = 'fc-on-shopify'; }
	var logoHtml = CFG.logo ? '<img src="' + esc( CFG.logo ) + '" alt="">' : I.logo;
	root.innerHTML =
		'<button id="fc-chat-toggle" type="button" aria-label="Open chat" aria-expanded="false" aria-controls="fc-chat-panel">' + I.chat + '<span>Ask us</span></button>' +
		'<div id="fc-chat-panel" role="dialog" aria-label="Falconclaw chat" hidden>' +
			'<div class="fcw-hd">' +
				'<div class="fcw-logo">' + logoHtml + '</div>' +
				'<div class="fcw-who">' +
					'<div class="fcw-name">Falconclaw</div>' +
					'<div class="fcw-st"><span class="fcw-dot"></span><span id="fc-chat-status">Kai · AI assistant</span></div>' +
				'</div>' +
				'<button id="fc-chat-close" type="button" aria-label="Close chat">' + I.x + '</button>' +
			'</div>' +
			'<div id="fc-chat-log" class="fcw-log" role="log" aria-live="polite"></div>' +
			'<div class="fcw-quick"></div>' +
			'<form id="fc-chat-form" class="fcw-ft">' +
				'<label class="fcw-sr" for="fc-chat-input">Message</label>' +
				'<textarea id="fc-chat-input" rows="1" maxlength="2000" placeholder="Ask us anything"></textarea>' +
				'<button type="submit" aria-label="Send">' + I.send + '</button>' +
			'</form>' +
		'</div>';
	document.body.appendChild( root );

	var toggle = root.querySelector( '#fc-chat-toggle' );
	var panel = root.querySelector( '#fc-chat-panel' );
	var log = root.querySelector( '#fc-chat-log' );
	var form = root.querySelector( '#fc-chat-form' );
	var input = root.querySelector( '#fc-chat-input' );
	var statusEl = root.querySelector( '#fc-chat-status' );
	var dotEl = root.querySelector( '.fcw-dot' );
	var quickEl = root.querySelector( '.fcw-quick' );

	/* ---------- small helpers ---------- */
	function esc( t ) {
		return String( t == null ? '' : t ).replace( /[&<>"']/g, function ( c ) {
			return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ c ];
		} );
	}
	function $( sel, r ) { return ( r || root ).querySelector( sel ); }
	function el( cls, html ) { var d = document.createElement( 'div' ); d.className = cls; d.innerHTML = html || ''; return d; }
	function scrollDown() {
		log.scrollTop = log.scrollHeight;
		if ( window.requestAnimationFrame ) { requestAnimationFrame( function () { log.scrollTop = log.scrollHeight; } ); }
	}
	function add( node ) {
		log.appendChild( node );
		if ( typingEl && node !== typingEl ) { log.appendChild( typingEl ); }   // dots stay last
		scrollDown();
		return node;
	}
	function okMail( v ) { return EMAIL_RE.test( v ); }
	function privacy() { return 'See our <a href="' + PRIVACY_URL + '" target="_blank" rel="noopener">privacy policy</a>.'; }
	function rid() { return Date.now().toString( 36 ) + Math.random().toString( 36 ).slice( 2, 10 ); }

	/* ---------- relay ---------- */
	// Never rejects: resolves {ok, status, data}. status 0 = network failure.
	function api( path, opts ) {
		opts = opts || {};
		var headers = {};
		if ( ! ( opts.body instanceof FormData ) ) { headers[ 'Content-Type' ] = 'application/json'; }
		if ( NONCE ) { headers[ 'X-WP-Nonce' ] = NONCE; }
		opts.headers = headers;
		opts.credentials = 'same-origin';
		return fetch( REST + path, opts ).then( function ( r ) {
			return r.json().catch( function () { return {}; } ).then( function ( d ) {
				return { ok: r.ok, status: r.status, data: d || {} };
			} );
		}, function () { return { ok: false, status: 0, data: {} }; } );
	}
	function post( path, body ) {
		body = body || {};
		body.conversation_id = convId;
		body.customer_token = custTok;
		return api( path, { method: 'POST', body: JSON.stringify( body ) } );
	}
	function authQuery() {
		return 'conversation_id=' + encodeURIComponent( convId ) + '&customer_token=' + encodeURIComponent( custTok );
	}

	// Which relay routes exist: one quiet GET of the namespace index per browser session.
	function detectCaps() {
		if ( capsPromise ) { return capsPromise; }
		var cached = null;
		try { cached = JSON.parse( sessionStorage.getItem( 'fc_chat_caps' ) || 'null' ); } catch ( e ) {}
		if ( cached && typeof cached === 'object' ) {
			caps = cached;
			capsPromise = Promise.resolve( caps );
			return capsPromise;
		}
		// The relay edge cache keeps the bare index for up to an hour after a deploy, so ask with
		// a 10-minute bucket: fresh within 10 minutes, still shared between visitors.
		capsPromise = api( '?fcw=' + Math.floor( Date.now() / 600000 ), { method: 'GET' } ).then( function ( r ) {
			var routes = ( r.ok && r.data && r.data.routes ) ? r.data.routes : null;
			if ( routes ) {
				var has = function ( p ) {
					for ( var k in routes ) {
						if ( Object.prototype.hasOwnProperty.call( routes, k ) && k.slice( -p.length ) === p ) { return true; }
					}
					return false;
				};
				caps = {
					rate: has( '/rate' ),
					form: has( '/form' ),
					orders: has( '/orders/request' ) && has( '/orders' ) && has( '/upload' ) && has( '/order-problem' )
				};
				try { sessionStorage.setItem( 'fc_chat_caps', JSON.stringify( caps ) ); } catch ( e ) {}
			}
			return caps;
		} );
		return capsPromise;
	}
	function orderFlowOn() { return ORDER_FLOW && caps.orders; }

	/* ---------- session ---------- */
	function saveSession() { try { localStorage.setItem( 'fc_chat_cid', convId ); localStorage.setItem( 'fc_chat_tok', custTok ); } catch ( e ) {} }
	function clearSession() { try { localStorage.removeItem( 'fc_chat_cid' ); localStorage.removeItem( 'fc_chat_tok' ); } catch ( e ) {} }
	function dropConversation() {
		convId = null; custTok = null; afterId = 0; lastStatus = null; agentName = '';
		S.hoSent = false; S.verified = false; pollStopped = false;
		clearSession(); resetFeedback(); renderStatus();
	}

	// KAI-LINK (27.10.2026): the Briefing visitor id, only while Shopify consent allows analytics AND marketing
	// (the same gate as fc-briefing.js). fc_vid stays in localStorage after a withdrawal, so its presence alone
	// is not consent. Read once, at /start: a chat resumed or started before consent stays unlinked.
	function briefingVid() {
		try {
			var p = window.Shopify && Shopify.customerPrivacy;
			if ( ! p || typeof p.analyticsProcessingAllowed !== 'function' || typeof p.marketingAllowed !== 'function' ||
				! p.analyticsProcessingAllowed() || ! p.marketingAllowed() ) { return null; }
			var v = localStorage.getItem( 'fc_vid' );
			return /^[0-9a-f]{32}$/.test( v || '' ) ? v : null;
		} catch ( e ) { return null; }
	}

	// Conversations are created on the first real action, never on open (no empty chats in the console).
	function ensureConv() {
		if ( convId ) { return Promise.resolve( true ); }
		if ( startPromise ) { return startPromise; }
		startPromise = api( '/start', { method: 'POST', body: JSON.stringify( {
			product_id: CFG.product_id, user: CFG.user || null, source: CFG.source || null, country: CFG.country || null,
			fc_vid: briefingVid()
		} ) } ).then( function ( r ) {
			startPromise = null;
			if ( r.data && r.data.conversation_id ) {
				convId = r.data.conversation_id; custTok = r.data.customer_token;
				pollStopped = false; saveSession(); poll();
				return true;
			}
			return false;
		} );
		return startPromise;
	}

	/* ---------- header status ---------- */
	function renderStatus() {
		var t = 'Kai · AI assistant', wait = false;
		if ( lastStatus === 'human' ) { t = ( agentName ? agentName + ' is in the chat' : 'A colleague is in the chat' ); }
		else if ( lastStatus === 'needs_human' || ( S.hoSent && lastStatus !== 'closed' ) ) { t = 'Request sent, reply in 1 to 3 business days'; wait = true; }
		else if ( lastStatus === 'closed' ) { t = 'Chat closed'; wait = true; }
		statusEl.textContent = t;
		dotEl.className = 'fcw-dot' + ( wait ? ' is-wait' : '' );
	}

	/* ---------- log items ---------- */
	function label( key, html ) {
		if ( labelRun === key ) { return; }
		labelRun = key;
		add( el( 'fcw-lbl', html ) );
	}
	function breakRun() { labelRun = null; }

	// Kai message. id = relay message id (thumbs need it). plain = local text, no thumbs.
	function botMsg( text, id, plain ) {
		label( 'bot', '<b>Kai</b> · AI assistant' );
		var w = el( 'fcw-bw', '<div class="fcw-m fcw-bot">' + ( plain ? text : fcRender( text ) ) + '</div>' );
		if ( ! plain && id && caps.rate ) { w.appendChild( thumbs( id ) ); }
		return add( w );
	}
	function agentMsg( name, text ) {
		label( 'agent:' + name, '<b>' + esc( name ) + '</b> · Falconclaw' );
		return add( el( 'fcw-bw', '<div class="fcw-m fcw-agent">' + fcRender( text ) + '</div>' ) );
	}
	function customerMsg( text ) {
		breakRun();
		var d = el( 'fcw-m fcw-me' );
		var t = document.createElement( 'span' ); t.textContent = text;
		var k = document.createElement( 'span' ); k.className = 'fcw-tick';
		d.appendChild( t ); d.appendChild( k );
		add( d );
		return k;
	}
	function setTick( k, state ) {
		if ( ! k ) { return; }
		k.innerHTML = state ? I.tick : '';
		k.className = 'fcw-tick' + ( state === 'read' ? ' is-read' : '' );
		if ( state ) { k.setAttribute( 'aria-label', state === 'read' ? 'Read' : 'Sent' ); }
	}
	function sys( text ) { breakRun(); return add( el( 'fcw-sys', esc( text ) ) ); }
	function note( kind, html ) {
		breakRun();
		var icon = kind === 'ok' ? I.ok : ( kind === 'alert' ? I.alert : I.clock );
		return add( el( 'fcw-note fcw-note--' + kind, icon + '<div>' + html + '</div>' ) );
	}

	// Progress bar while Kai writes: a timed guess, not real progress (replies took 12 to 18 s on 19.10.2026).
	// Fast at first, 90 percent at 15 s, then a slow creep to 97 so it never looks frozen. Returns [percent, words].
	function typingStage( ms ) {
		var s = ms / 1000, p = Math.min( s / 15, 1 );
		var pct = s < 15 ? 90 * ( 1 - ( 1 - p ) * ( 1 - p ) ) : 90 + 7 * Math.min( ( s - 15 ) / 45, 1 );
		var words = 'Taking longer than usual, still working';
		if ( s < 3 ) { words = 'Reading your question'; } else if ( s < 9 ) { words = 'Checking our answers'; } else if ( s < 25 ) { words = 'Writing the reply'; }
		return [ Math.round( pct ), words ];
	}
	var typingTimer = null;
	function showTyping() {
		if ( typingEl ) { return; }
		var t0 = pendingSince || Date.now();
		typingEl = el( 'fcw-typing', '<progress max="100" value="0" aria-hidden="true"></progress><span class="fcw-stage" aria-hidden="true"></span><span class="fcw-sr">Kai is typing</span>' );
		var bar = typingEl.querySelector( 'progress' ), stage = typingEl.querySelector( '.fcw-stage' );
		function tick() { var s = typingStage( Date.now() - t0 ); bar.value = s[ 0 ]; stage.textContent = s[ 1 ]; }
		tick();
		typingTimer = setInterval( tick, 250 );   // local only, no network; cleared in hideTyping
		add( typingEl );
	}
	function hideTyping( done ) {   // done = a reply arrived: fill to 100, then go
		if ( ! typingEl ) { return; }
		clearInterval( typingTimer );
		var t = typingEl; typingEl = null;
		if ( ! done ) { t.remove(); return; }
		t.querySelector( 'progress' ).value = 100;
		setTimeout( function () { t.remove(); }, 300 );
	}

	/* ---------- per-answer thumbs (relay 0.6 /rate only) ---------- */
	function thumbs( id ) {
		var fb = el( 'fcw-fb',
			'<button type="button" class="fcw-up" aria-label="Good answer" aria-pressed="false">' + I.up + '</button>' +
			'<button type="button" class="fcw-dn" aria-label="Bad answer" aria-pressed="false">' + I.down + '</button>' +
			'<span class="fcw-said" aria-live="polite"></span>' );
		var btns = fb.querySelectorAll( 'button' );
		Array.prototype.forEach.call( btns, function ( b ) {
			b.addEventListener( 'click', function () {
				var was = b.getAttribute( 'aria-pressed' ) === 'true';
				Array.prototype.forEach.call( btns, function ( x ) { x.setAttribute( 'aria-pressed', 'false' ); x.classList.remove( 'is-on' ); } );
				var value = 'none';
				if ( ! was ) { b.setAttribute( 'aria-pressed', 'true' ); b.classList.add( 'is-on' ); value = b.classList.contains( 'fcw-up' ) ? 'up' : 'down'; }
				fb.classList.toggle( 'is-done', value !== 'none' );
				$( '.fcw-said', fb ).textContent = value === 'up' ? 'Thanks' : ( value === 'down' ? 'Noted, thanks' : '' );
				if ( convId ) { post( '/rate', { message_id: id, value: value } ); }
			} );
		} );
		return fb;
	}

	/* ---------- end-of-chat rating (old eligibility timing, new faces card) ---------- */
	function fbEligible() {
		return botReplied && customerAsked && ! fbRated && lastStatus !== 'needs_human' && lastStatus !== 'human';
	}
	function armFeedback() {
		if ( ! fbEligible() || document.getElementById( 'fcw-rate' ) ) { return; }
		if ( fbTimer ) { clearTimeout( fbTimer ); }
		fbTimer = setTimeout( function () { if ( fbEligible() ) { showRating(); } }, closingHint ? FB_CLOSE_MS : FB_IDLE_MS );
	}
	function feedbackOnCustomerMsg( text ) {
		closingHint = FB_CLOSE_RE.test( text || '' );
		if ( fbTimer ) { clearTimeout( fbTimer ); fbTimer = null; }
	}
	function resetFeedback() {
		fbRated = false; botReplied = false; customerAsked = false; closingHint = false;
		if ( fbTimer ) { clearTimeout( fbTimer ); fbTimer = null; }
		var r = document.getElementById( 'fcw-rate' ); if ( r ) { r.remove(); }
	}
	function showRating() {
		var c = card( 'fcw-rate', '<h3 class="fcw-center">How was your chat?</h3><div class="fcw-faces">' +
			'<button type="button" data-v="great">' + FACE.great + 'Great</button>' +
			'<button type="button" data-v="ok">' + FACE.ok + 'OK</button>' +
			'<button type="button" data-v="poor">' + FACE.poor + 'Poor</button></div>', true );
		Array.prototype.forEach.call( c.querySelectorAll( 'button' ), function ( b ) {
			b.addEventListener( 'click', function () {
				fbRated = true;
				sendEndRating( b.getAttribute( 'data-v' ) );
				c.remove();
				sys( 'Thanks for the feedback.' );
			} );
		} );
	}
	function sendEndRating( v ) {
		if ( ! convId ) { return; }
		if ( caps.form || caps.rate ) { post( '/feedback', { rating: v } ); return; }   // relay 0.6
		var legacy = v === 'great' ? 'good' : ( v === 'poor' ? 'bad' : '' );      // relay 0.5 knows good|bad only
		if ( legacy ) { post( '/feedback', { rating: legacy } ); }
	}

	/* ---------- cards: a form is never lost, asking again moves it to the bottom ---------- */
	function card( id, html, noFocus ) {
		var old = document.getElementById( id );
		breakRun();
		if ( old ) {
			add( old );
			focusFirst( old, noFocus );
			return old;
		}
		var c = el( 'fcw-card', html );
		c.id = id;
		add( c );
		focusFirst( c, noFocus );
		return c;
	}
	function focusFirst( c, noFocus ) {
		if ( noFocus ) { return; }
		var f = c.querySelector( 'input:not([type=checkbox]),textarea,select' );
		if ( f ) { setTimeout( function () { try { f.focus( { preventScroll: true } ); } catch ( e ) { f.focus(); } }, 260 ); }
	}
	function fail( c, msg ) { var e = $( '.fcw-err', c ); e.textContent = msg; e.hidden = false; }
	function clearErr( c ) { var e = $( '.fcw-err', c ); if ( e ) { e.hidden = true; } }
	function busy( btn, on, text ) { btn.disabled = on; if ( text ) { btn.textContent = text; } }
	function field( id, lbl, type, ph, val, extra ) {
		return '<label for="' + id + '">' + lbl + '</label>' +
			'<input type="' + type + '" id="' + id + '"' + ( ph ? ' placeholder="' + esc( ph ) + '"' : '' ) +
			( val ? ' value="' + esc( val ) + '"' : '' ) + ( extra || '' ) + '>';
	}
	function area( id, lbl, ph, extra ) {
		return '<label for="' + id + '">' + lbl + '</label><textarea id="' + id + '"' + ( ph ? ' placeholder="' + esc( ph ) + '"' : '' ) + ( extra || '' ) + '></textarea>';
	}
	function check( id, lbl, checked ) {
		return '<label class="fcw-chk" for="' + id + '"><input type="checkbox" id="' + id + '"' + ( checked ? ' checked' : '' ) + '>' + lbl + '</label>';
	}
	var ERR = '<div class="fcw-err" role="alert" hidden></div>';
	function val( c, sel ) { var f = $( sel, c ); return f ? f.value.trim() : ''; }

	// Relay 0.6 /form event. Resolves true when stored, false when the route is missing (404) so the
	// caller falls back, or null on any other failure.
	function sendForm( kind, fields ) {
		if ( ! caps.form ) { return Promise.resolve( false ); }
		return post( '/form', { kind: kind, fields: fields } ).then( function ( r ) {
			if ( r.ok ) { return true; }
			if ( r.status === 404 ) { caps.form = false; return false; }
			return null;
		} );
	}

	// The form event is stored; /contact with request_human is what flags the chat for a person.
	// The event already counts as delivered, so a failed flag does not make the customer resend.
	function alertPerson( name, email ) {
		return post( '/contact', { name: name, email: email, request_human: true } ).then( function () { return true; } );
	}

	/* ---------- Talk to a person ---------- */
	function showHandoff() {
		var c = card( 'fcw-ho', '<h3>Talk to a person</h3><p class="fcw-sub">A colleague replies by email within 1 to 3 business days. Leave your details so they can reach you.</p>' +
			field( 'fcw-ho-n', 'Your name', 'text', 'How should we address you?', S.name, ' maxlength="80" autocomplete="name"' ) +
			field( 'fcw-ho-e', 'Email', 'email', 'you@example.com', S.email, ' maxlength="190" autocomplete="email"' ) +
			area( 'fcw-ho-t', 'What is it about? (optional)', 'A short note helps us answer in one go', ' maxlength="600"' ) +
			check( 'fcw-ho-nl', 'Also send me the Falconclaw newsletter' ) +
			ERR + '<div class="fcw-row"><button class="fcw-btn" type="button">Send to the team</button><button class="fcw-btn fcw-btn--ghost" type="button">Not now</button></div>' +
			'<div class="fcw-fine">We store your name and email only to reply to you. ' + privacy() + '</div>' );
		if ( c.getAttribute( 'data-wired' ) ) { return; }
		c.setAttribute( 'data-wired', '1' );
		var b = c.querySelectorAll( '.fcw-row button' );
		b[ 0 ].addEventListener( 'click', function () {
			var name = val( c, '#fcw-ho-n' ), email = val( c, '#fcw-ho-e' ), noteText = val( c, '#fcw-ho-t' );
			var news = $( '#fcw-ho-nl', c ).checked;
			clearErr( c );
			if ( ! name ) { return fail( c, 'Please add your name.' ); }
			if ( ! okMail( email ) ) { return fail( c, 'Please check the email address.' ); }
			busy( b[ 0 ], true, 'Sending' );
			ensureConv().then( function ( ok ) {
				if ( ! ok ) { return null; }
				return sendForm( 'handoff', { name: name, email: email, note: noteText, newsletter: news ? 'yes' : 'no' } ).then( function ( done ) {
					if ( done ) { return alertPerson( name, email ); }
					if ( done === null ) { return null; }
					// Relay 0.5: today's contact line (the console turns it into a form card) plus /contact.
					var line = '📋 Contact details — Name: ' + name + ' · Email: ' + email +
						' · Newsletter: ' + ( news ? 'yes' : 'no' ) + ( noteText ? ' · Note: ' + noteText : '' );
					return post( '/message', { text: line } ).then( function ( r ) {
						if ( ! r.ok ) { return null; }
						return post( '/contact', { name: name, email: email, request_human: true } ).then( function ( r2 ) { return r2.ok || null; } );
					} );
				} );
			} ).then( function ( done ) {
				if ( ! done ) { busy( b[ 0 ], false, 'Send to the team' ); return fail( c, 'Sending failed. Please try again.' ); }
				if ( news ) { fcSibSubmit( email, [ '10' ] ); }
				S.name = name; S.email = email; S.hoSent = true; S.hoSkipped = false;
				c.remove();
				note( 'wait', '<b>Thanks, ' + esc( name ) + '. Your request is with the team.</b><br>A colleague replies to ' + esc( email ) + ' within 1 to 3 business days. You can keep asking me in the meantime.' );
				if ( lastStatus !== 'human' ) { lastStatus = 'needs_human'; }
				renderStatus();
			} );
		} );
		b[ 1 ].addEventListener( 'click', function () {
			c.remove();
			S.hoSkipped = true;
			botMsg( 'No problem. Say "person" any time and I bring the form back.', null, true );
		} );
	}

	/* ---------- Request a quote ---------- */
	function showQuote() {
		var c = card( 'fcw-rq', '<h3>Request a quote</h3><p class="fcw-sub">A colleague sends the quote by email within 1 to 3 business days.</p>' +
			'<div class="fcw-note fcw-note--wait fcw-note--in">' + I.alert + '<div><b>Quotes are for orders above 10&nbsp;000 EUR.</b><br>For smaller orders the bulk offer on the product page applies, no quote needed.</div></div>' +
			field( 'fcw-rq-n', 'Your name', 'text', 'How should we address you?', S.name, ' maxlength="80" autocomplete="name"' ) +
			field( 'fcw-rq-e', 'Email', 'email', 'you@example.com', S.email, ' maxlength="190" autocomplete="email"' ) +
			area( 'fcw-rq-t', 'What would you like a quote for?', 'Products and quantities', ' maxlength="600"' ) +
			ERR + '<div class="fcw-row"><button class="fcw-btn" type="button">Send request</button></div>' +
			'<div class="fcw-fine">We store your details only to prepare your quote and reply. ' + privacy() + '</div>' );
		if ( c.getAttribute( 'data-wired' ) ) { return; }
		c.setAttribute( 'data-wired', '1' );
		var btn = $( '.fcw-btn', c );
		btn.addEventListener( 'click', function () {
			var name = val( c, '#fcw-rq-n' ), email = val( c, '#fcw-rq-e' ), det = val( c, '#fcw-rq-t' );
			clearErr( c );
			if ( ! name ) { return fail( c, 'Please add your name.' ); }
			if ( ! okMail( email ) ) { return fail( c, 'Please check the email address.' ); }
			if ( ! det ) { return fail( c, 'Please tell us what the quote is for.' ); }
			busy( btn, true, 'Sending' );
			ensureConv().then( function ( ok ) {
				if ( ! ok ) { return null; }
				return sendForm( 'quote', { name: name, email: email, details: det, over_10k: 'yes' } ).then( function ( done ) {
					if ( done ) { return alertPerson( name, email ); }
					if ( done === null ) { return null; }
					var line = '🧾 Quote request — Name: ' + name + ' · Email: ' + email + ' · Wants: ' + det;
					return post( '/message', { text: line } ).then( function ( r ) {
						if ( ! r.ok ) { return null; }
						return post( '/contact', { name: name, email: email, request_human: true } ).then( function ( r2 ) { return r2.ok || null; } );
					} );
				} );
			} ).then( function ( done ) {
				if ( ! done ) { busy( btn, false, 'Send request' ); return fail( c, 'Sending failed. Please try again.' ); }
				S.name = name; S.email = email; S.hoSent = true;
				c.remove();
				note( 'ok', '<b>Quote request received.</b><br>A colleague sends it to ' + esc( email ) + ' within 1 to 3 business days.' );
				if ( lastStatus !== 'human' ) { lastStatus = 'needs_human'; }
				renderStatus();
			} );
		} );
	}

	/* ---------- Request a cable (inline; same Apps Script as today, which feeds dispatch) ---------- */
	function showCable() {
		var c = card( 'fcw-cr', '<h3>Request a cable</h3><p class="fcw-sub">Tell us which radio you run. We build new cables based on demand. You get one email when this cable is released.</p>' +
			field( 'fcw-cr-r', 'Radio model', 'text', 'For example IC-F3400D', '', ' maxlength="120"' ) +
			field( 'fcw-cr-p', 'Connector or port (if known)', 'text', 'For example 14-pin side connector', '', ' maxlength="120"' ) +
			field( 'fcw-cr-e', 'Email', 'email', 'you@example.com', S.email, ' maxlength="190" autocomplete="email"' ) +
			check( 'fcw-cr-nl', 'Also send me the Falconclaw newsletter' ) +
			ERR + '<div class="fcw-row"><button class="fcw-btn" type="button">Send request</button></div>' +
			'<div class="fcw-fine">We use your email only for this one notice. ' + privacy() + '</div>' );
		if ( c.getAttribute( 'data-wired' ) ) { return; }
		c.setAttribute( 'data-wired', '1' );
		$( '.fcw-btn', c ).addEventListener( 'click', function () {
			var radio = val( c, '#fcw-cr-r' ), port = val( c, '#fcw-cr-p' ), email = val( c, '#fcw-cr-e' );
			var news = $( '#fcw-cr-nl', c ).checked;
			clearErr( c );
			if ( radio.length < 2 ) { return fail( c, 'Please add the radio model.' ); }
			if ( ! okMail( email ) ) { return fail( c, 'Please check the email address.' ); }
			// Dispatch feed: the Google Sheet, exactly as the old widget posted it. Fire and forget.
			try {
				var gs = new FormData();
				gs.append( 'fc_form', 'ptt_cable' );
				gs.append( 'source', 'chat-widget' );
				gs.append( 'radio_model', radio );
				gs.append( 'connector', port );
				gs.append( 'email', email );
				fetch( CABLE_SHEET_URL, { method: 'POST', mode: 'no-cors', body: gs } ).catch( function () {} );
			} catch ( e ) {}
			if ( news ) { fcSibSubmit( email, [ '10' ] ); }
			// Chat record, only when a conversation already exists (as today).
			if ( convId ) {
				sendForm( 'cable', { radio: radio, port: port, email: email, newsletter: news ? 'yes' : 'no' } ).then( function ( done ) {
					if ( done === false ) {
						post( '/message', { text: 'CABLE REQUEST — radio: ' + radio + ' | port: ' + port + ' | email: ' + email } );
					}
				} );
			}
			S.email = email;
			c.remove();
			note( 'ok', '<b>Request received for ' + esc( radio ) + '.</b><br>You get one email when this cable is released.' );
		} );
	}

	/* ---------- Back in stock (only with a product handle; relay /restock/subscribe) ---------- */
	var product = null;   // {handle, title, url, variants:[{id,title,available}]}
	var productPromise = null;
	function productHandle() {
		var m = location.pathname.match( /\/products\/([a-z0-9][a-z0-9-]{0,188})/i );
		return m ? m[ 1 ].toLowerCase() : '';
	}
	function loadProduct() {
		if ( productPromise ) { return productPromise; }
		var h = productHandle();
		if ( ! h ) { productPromise = Promise.resolve( null ); return productPromise; }
		productPromise = fetch( '/products/' + h + '.js', { credentials: 'same-origin' } ).then( function ( r ) {
			return r.ok ? r.json() : null;
		} ).then( function ( p ) {
			if ( ! p ) { return null; }
			product = { handle: h, title: p.title || '', url: location.origin + '/products/' + h,
				variants: ( p.variants || [] ).map( function ( v ) { return { id: String( v.id ), title: v.title, available: !! v.available }; } ) };
			return product;
		}, function () { return null; } );
		return productPromise;
	}
	function currentVariant() {
		if ( ! product || ! product.variants.length ) { return null; }
		var id = '';
		var m = location.search.match( /[?&]variant=(\d+)/ );
		if ( m ) { id = m[ 1 ]; }
		if ( ! id ) {
			var f = document.querySelector( 'form[action*="/cart/add"] [name="id"]' );
			if ( f && f.value ) { id = String( f.value ); }
		}
		for ( var i = 0; i < product.variants.length; i++ ) { if ( product.variants[ i ].id === id ) { return product.variants[ i ]; } }
		return product.variants[ 0 ];
	}
	function showStock() {
		if ( ! product ) { return; }
		S.stockOffered = true;
		var v = currentVariant();
		var multi = product.variants.length > 1;
		var pname = product.title + ( multi && v ? ' (' + v.title + ')' : '' );
		var c = card( 'fcw-bs', '<h3>Tell me when it is back</h3><p class="fcw-sub">We do not know when, or if, this item returns. Leave your email and you get exactly one email if it does. No newsletter, nothing else.</p>' +
			'<div class="fcw-prod"><span>Product</span><span>' + esc( pname ) + '</span></div>' +
			field( 'fcw-bs-e', 'Email', 'email', 'you@example.com', S.email, ' maxlength="190" autocomplete="email"' ) +
			ERR + '<div class="fcw-row"><button class="fcw-btn" type="button">Notify me</button></div>' +
			'<div class="fcw-fine">One email, then we delete the request. ' + privacy() + '</div>' );
		if ( c.getAttribute( 'data-wired' ) ) { return; }
		c.setAttribute( 'data-wired', '1' );
		var btn = $( '.fcw-btn', c );
		btn.addEventListener( 'click', function () {
			var email = val( c, '#fcw-bs-e' );
			clearErr( c );
			if ( ! okMail( email ) ) { return fail( c, 'Please check the email address.' ); }
			var fields = {
				email: email, handle: product.handle, title: product.title,
				variant_id: multi && v ? v.id : '', variant_title: multi && v ? v.title : '',
				url: product.url + ( multi && v ? '?variant=' + v.id : '' )
			};
			busy( btn, true, 'Sending' );
			// Relay 0.6 with a conversation: /form records the event AND writes the restock watch.
			// Otherwise (or on a 404): the same /restock/subscribe the product page form uses.
			var viaForm = convId && caps.form
				? post( '/form', { kind: 'restock', fields: { email: email, handle: product.handle, product: product.title,
					variant: fields.variant_title, variant_id: fields.variant_id, url: fields.url } } )
				: Promise.resolve( { ok: false, status: 404 } );
			viaForm.then( function ( r ) {
				if ( r.ok || r.status !== 404 ) { return r; }
				return api( '/restock/subscribe', { method: 'POST', body: JSON.stringify( fields ) } );
			} ).then( function ( r ) {
				if ( ! r.ok ) {
					busy( btn, false, 'Notify me' );
					var code = r.data && r.data.code;
					return fail( c, code === 'bad_email' ? 'Please check the email address.' :
						( code === 'flood' || code === 'rate_limited' ? 'Too many requests. Please try again later.' : 'Sending failed. Please try again.' ) );
				}
				S.email = email;
				c.remove();
				note( 'ok', '<b>You are on the list.</b><br>One email to ' + esc( email ) + ' if it comes back in stock.' );
			} );
		} );
	}

	/* ---------- Newsletter (inline; same Brevo form post as the site footer) ---------- */
	function showNewsletter() {
		var c = card( 'fcw-nl', '<h3>Falconclaw newsletter</h3><p class="fcw-sub">New products, cables and offers. Unsubscribe any time.</p>' +
			field( 'fcw-nl-e', 'Email', 'email', 'you@example.com', S.email, ' maxlength="190" autocomplete="email"' ) +
			check( 'fcw-nl-10', 'New products', true ) +
			check( 'fcw-nl-11', 'New long-form YouTube videos' ) +
			check( 'fcw-nl-14', 'New course notifications' ) +
			ERR + '<div class="fcw-row"><button class="fcw-btn" type="button">Subscribe</button><button class="fcw-btn fcw-btn--ghost" type="button">Cancel</button></div>' );
		if ( c.getAttribute( 'data-wired' ) ) { return; }
		c.setAttribute( 'data-wired', '1' );
		var b = c.querySelectorAll( '.fcw-row button' );
		b[ 0 ].addEventListener( 'click', function () {
			var email = val( c, '#fcw-nl-e' );
			clearErr( c );
			if ( ! okMail( email ) ) { return fail( c, 'Please check the email address.' ); }
			var lists = [];
			[ '10', '11', '14' ].forEach( function ( L ) { if ( $( '#fcw-nl-' + L, c ).checked ) { lists.push( L ); } } );
			if ( ! lists.length ) { lists = [ '10' ]; }
			fcSibSubmit( email, lists );
			if ( convId ) { sendForm( 'newsletter', { email: email, lists: lists.join( ',' ) } ); }
			S.email = email;
			c.remove();
			note( 'ok', '<b>Almost there.</b><br>Check your inbox and confirm the subscription.' );
		} );
		b[ 1 ].addEventListener( 'click', function () { c.remove(); } );
	}

	// Brevo: the same plain form POST as the site footer (the token in the URL is the auth),
	// through a hidden iframe so the customer stays in the chat. Brevo sends its own confirmation.
	function fcSibSubmit( email, lists ) {
		if ( ! CFG.sib_url ) { return; }
		var name = 'fcw-sib-' + Date.now();
		var iframe = document.createElement( 'iframe' ); iframe.name = name; iframe.style.display = 'none'; iframe.title = 'Newsletter';
		document.body.appendChild( iframe );
		var f = document.createElement( 'form' );
		f.method = 'POST'; f.action = CFG.sib_url; f.target = name; f.style.display = 'none';
		function addIn( n, v ) { var i = document.createElement( 'input' ); i.type = 'hidden'; i.name = n; i.value = v; f.appendChild( i ); }
		addIn( 'EMAIL', email );
		( lists || [ '10' ] ).forEach( function ( L ) { addIn( 'lists_25[]', L ); } );
		addIn( 'email_address_check', '' );
		addIn( 'locale', 'en' );
		document.body.appendChild( f );
		f.submit();
		setTimeout( function () { try { f.remove(); iframe.remove(); } catch ( e ) {} }, 5000 );
	}

	/* ---------- Verify email (6-digit code) ---------- */
	var VERIFY_ERR = {
		throttle: 'A code was just sent. Please wait a minute before asking for another.',
		email: 'Please check the email address.',
		bad: 'That code is not correct.',
		expired: 'The code has expired. Ask for a new one.',
		locked: 'Too many attempts. Ask for a new code.',
		nocode: 'Ask for a code first.'
	};
	function showVerify( next ) {
		if ( next ) { S.verifyNext = next; }
		if ( S.verified && S.verifyNext ) { var n = S.verifyNext; S.verifyNext = null; return n(); }
		var c = card( 'fcw-vf', '' );
		if ( c.getAttribute( 'data-wired' ) ) { return; }
		c.setAttribute( 'data-wired', '1' );
		stepEmail();

		function stepEmail() {
			c.innerHTML = '<h3>Verify your email</h3><p class="fcw-sub">To show your orders we email you a 6-digit code. Use the email you ordered with.</p>' +
				field( 'fcw-vf-e', 'Email', 'email', 'you@example.com', S.email, ' maxlength="190" autocomplete="email"' ) +
				ERR + '<div class="fcw-row"><button class="fcw-btn" type="button">Send code</button></div>';
			focusFirst( c );
			var btn = $( '.fcw-btn', c );
			btn.addEventListener( 'click', function () {
				var email = val( c, '#fcw-vf-e' );
				clearErr( c );
				if ( ! okMail( email ) ) { return fail( c, VERIFY_ERR.email ); }
				busy( btn, true, 'Sending' );
				request( email ).then( function ( err ) {
					if ( err ) { busy( btn, false, 'Send code' ); return fail( c, err ); }
					S.email = email;
					stepCode( email );
				} );
			} );
		}
		function request( email ) {
			return ensureConv().then( function ( ok ) {
				if ( ! ok ) { return 'We could not send the code. Please try again.'; }
				return post( '/verify/request', { email: email } ).then( function ( r ) {
					if ( r.ok && r.data.ok ) { return ''; }
					return VERIFY_ERR[ r.data && r.data.code ] || 'We could not send the code. Please try again.';
				} );
			} );
		}
		function stepCode( email ) {
			c.innerHTML = '<h3>Enter the code</h3><p class="fcw-sub">We sent a 6-digit code to ' + esc( email ) + '. It is valid for 10 minutes.</p>' +
				field( 'fcw-vf-c', '6-digit code', 'text', '000000', '', ' class="fcw-code" inputmode="numeric" autocomplete="one-time-code" maxlength="6"' ) +
				ERR + '<div class="fcw-row"><button class="fcw-btn" type="button">Verify</button></div>' +
				'<div class="fcw-fine"><button class="fcw-link" type="button" data-a="resend">Send a new code</button> <button class="fcw-link" type="button" data-a="change">Use another email</button></div>';
			var code = $( '#fcw-vf-c', c );
			focusFirst( c );
			code.addEventListener( 'input', function () { code.value = code.value.replace( /\D/g, '' ).slice( 0, 6 ); } );
			var btn = $( '.fcw-btn', c );
			btn.addEventListener( 'click', function () {
				clearErr( c );
				if ( code.value.length !== 6 ) { return fail( c, 'The code has 6 digits.' ); }
				busy( btn, true, 'Checking' );
				post( '/verify/confirm', { email: email, code: code.value } ).then( function ( r ) {
					if ( r.ok && r.data.verified ) {
						S.verified = true;
						c.remove();
						note( 'ok', '<b>Email verified.</b> ' + esc( email ) + ( orderFlowOn() ? '' : '. Ask me about your order.' ) );
						if ( S.verifyNext ) { var n = S.verifyNext; S.verifyNext = null; n(); }
						return;
					}
					busy( btn, false, 'Verify' );
					fail( c, VERIFY_ERR[ r.data && r.data.code ] || 'That code is not correct.' );
				} );
			} );
			$( '[data-a=resend]', c ).addEventListener( 'click', function () {
				var link = this;
				clearErr( c );
				request( email ).then( function ( err ) {
					if ( err ) { return fail( c, err ); }
					link.textContent = 'New code sent';
				} );
			} );
			$( '[data-a=change]', c ).addEventListener( 'click', function () { stepEmail(); } );
		}
	}

	/* ---------- Order problem flow (ORDER_FLOW, relay order routes) ---------- */
	var PROBLEMS = [
		[ 'late', 'It has not arrived', 'Tracking and delivery', I.truck ],
		[ 'broken', 'Damaged or not working', 'Fault, damage in transit', I.alert ],
		[ 'wrong', 'Wrong or missing item', 'Not what I ordered', I.swap ],
		[ 'return', 'I want to return it', 'Change of mind', I.undo ],
		[ 'change', 'Cancel or change the order', 'Address, items, cancel', I.edit ],
		[ 'invoice', 'Invoice or payment', 'Invoice, refund, bank transfer', I.doc ]
	];
	var ORDER_ERR = {
		not_verified: 'Please verify your email first.',
		order_not_owned: 'That order is not linked to your email.',
		rate_limited: 'Too many requests. Please try again in a few minutes.'
	};
	function startOrderFlow() {
		if ( ! orderFlowOn() ) { return; }
		if ( S.verified ) { return loadOrders(); }
		botMsg( 'I can help with that. First I need to know it is your order.', null, true );
		showVerify( loadOrders );
	}
	function orderFail( code ) {
		hideTyping();
		if ( code === 'not_verified' ) { S.verified = false; return showVerify( loadOrders ); }
		botMsg( esc( ORDER_ERR[ code ] || 'I could not open the case myself. A colleague can take it from here.' ), null, true );
		if ( ! ORDER_ERR[ code ] ) { showHandoff(); }
	}
	function loadOrders() {
		showTyping();
		post( '/orders/request', {} ).then( function ( r ) {
			if ( ! r.ok ) { return orderFail( r.data && r.data.code ); }
			var tries = 0;
			( function again() {
				api( '/orders?' + authQuery() ).then( function ( g ) {
					if ( g.ok && g.data.ready ) { hideTyping(); return pickOrder( g.data.orders || [] ); }
					if ( ! g.ok && g.status !== 404 ) { return orderFail( g.data && g.data.code ); }
					if ( ++tries > 12 ) { return orderFail( 'timeout' ); }
					setTimeout( again, 1500 );
				} );
			} )();
		} );
	}
	function pickOrder( orders ) {
		if ( ! orders.length ) {
			botMsg( 'I could not find orders for this email. A colleague can look it up.', null, true );
			return showHandoff();
		}
		botMsg( 'Here are your orders. Which one is it about?', null, true );
		var h = '<h3>Your orders</h3><div class="fcw-pick">';
		orders.forEach( function ( o, i ) {
			h += '<button class="fcw-opt" type="button" data-i="' + i + '">' + I.box + '<span><span class="fcw-t">' + esc( o.number ) +
				( o.items ? ' · ' + esc( [].concat( o.items ).join( ', ' ) ) : '' ) + '</span><span class="fcw-d">' + esc( o.date || '' ) +
				'</span></span><span class="fcw-tag">' + esc( o.status || '' ) + '</span></button>';
		} );
		h += '</div><div class="fcw-fine"><button class="fcw-link" type="button">My order is not listed</button></div>';
		var old = document.getElementById( 'fcw-orders' ); if ( old ) { old.remove(); }
		var c = card( 'fcw-orders', h, true );
		Array.prototype.forEach.call( c.querySelectorAll( '.fcw-opt' ), function ( b ) {
			b.addEventListener( 'click', function () { c.remove(); pickProblem( orders[ +b.getAttribute( 'data-i' ) ] ); } );
		} );
		$( '.fcw-link', c ).addEventListener( 'click', function () { c.remove(); botMsg( 'Then a colleague has to look it up.', null, true ); showHandoff(); } );
	}
	function pickProblem( order ) {
		botMsg( 'What is the problem with ' + esc( order.number ) + '?', null, true );
		var h = '<h3>What happened?</h3><div class="fcw-pick">';
		PROBLEMS.forEach( function ( p, i ) {
			h += '<button class="fcw-opt" type="button" data-i="' + i + '">' + p[ 3 ] + '<span><span class="fcw-t">' + p[ 1 ] + '</span><span class="fcw-d">' + p[ 2 ] + '</span></span></button>';
		} );
		var old = document.getElementById( 'fcw-problem' ); if ( old ) { old.remove(); }
		var c = card( 'fcw-problem', h + '</div>', true );
		Array.prototype.forEach.call( c.querySelectorAll( '.fcw-opt' ), function ( b ) {
			b.addEventListener( 'click', function () { c.remove(); orderDetails( order, PROBLEMS[ +b.getAttribute( 'data-i' ) ] ); } );
		} );
	}
	function orderDetails( order, problem ) {
		var k = problem[ 0 ], f = '', lead = '';
		var photo = '<label class="fcw-file" for="fcw-od-ph">' + I.clip + '<span>Add photos</span><input type="file" id="fcw-od-ph" accept="image/*" multiple></label>';
		if ( k === 'late' ) { lead = 'If the tracking does not settle it, I open a case.'; f = area( 'fcw-od-t', 'Anything we should know? (optional)', 'For example: neighbour checked, parcel locker empty', ' maxlength="600"' ); }
		if ( k === 'broken' ) { lead = 'Sorry about that. A few details so the team can decide without asking again.'; f = area( 'fcw-od-t', 'What is wrong?', 'What happens, and since when', ' maxlength="600" data-req' ) + photo; }
		if ( k === 'wrong' ) { lead = 'Sorry about that. Tell me what arrived.'; f = area( 'fcw-od-t', 'What did you receive instead, or what is missing?', '', ' maxlength="600" data-req' ) + photo; }
		if ( k === 'return' ) {
			lead = 'Returns go by a prepaid DHL label that we send you. You choose courier pickup or a parcel locker.';
			f = '<label for="fcw-od-r">Reason</label><select id="fcw-od-r"><option>Changed my mind</option><option>Does not fit my setup</option><option>Ordered the wrong item</option><option>Other</option></select>' +
				'<label for="fcw-od-u">Is the item unused and in its packaging?</label><select id="fcw-od-u"><option>Yes</option><option>No</option></select>';
		}
		if ( k === 'change' ) { lead = 'I cannot change an order myself. I pass the request to the team.'; f = area( 'fcw-od-t', 'What should change?', 'New address, different item, or cancel', ' maxlength="600" data-req' ); }
		if ( k === 'invoice' ) { lead = 'Money questions always go to a person.'; f = area( 'fcw-od-t', 'What do you need?', 'For example: invoice with company details', ' maxlength="600" data-req' ); }
		botMsg( esc( lead ), null, true );
		var c = card( 'fcw-od', '<h3>' + esc( problem[ 1 ] ) + '</h3><p class="fcw-sub">Order ' + esc( order.number ) + '</p>' + f +
			ERR + '<div class="fcw-row"><button class="fcw-btn" type="button">Open a case</button><button class="fcw-btn fcw-btn--ghost" type="button">Back</button></div>' );
		var fi = $( '.fcw-file input', c );
		if ( fi ) {
			fi.addEventListener( 'change', function () {
				$( '.fcw-file span', c ).textContent = fi.files.length + ' photo' + ( fi.files.length === 1 ? '' : 's' ) + ' added';
			} );
		}
		var b = c.querySelectorAll( '.fcw-row button' );
		b[ 1 ].addEventListener( 'click', function () { c.remove(); pickProblem( order ); } );
		b[ 0 ].addEventListener( 'click', function () {
			var req = $( '[data-req]', c );
			clearErr( c );
			if ( req && ! req.value.trim() ) { return fail( c, 'Please fill in the description.' ); }
			var files = fi ? Array.prototype.slice.call( fi.files, 0, 4 ) : [];
			if ( files.some( function ( x ) { return x.size > 6 * 1024 * 1024; } ) ) { return fail( c, 'Each photo can be up to 6 MB.' ); }
			var fields = {};
			Array.prototype.forEach.call( c.querySelectorAll( 'textarea,select' ), function ( x ) { fields[ x.id.replace( 'fcw-od-', '' ) ] = x.value.trim(); } );
			busy( b[ 0 ], true, 'Sending' );
			var ids = [];
			var chain = Promise.resolve( true );
			files.forEach( function ( file ) {
				chain = chain.then( function ( ok ) {
					if ( ! ok ) { return false; }
					var fd = new FormData();
					fd.append( 'conversation_id', convId ); fd.append( 'customer_token', custTok ); fd.append( 'file', file );
					return api( '/upload', { method: 'POST', body: fd } ).then( function ( r ) {
						if ( r.ok && r.data.photo_id ) { ids.push( r.data.photo_id ); return true; }
						return false;
					} );
				} );
			} );
			chain.then( function ( ok ) {
				if ( ! ok ) { busy( b[ 0 ], false, 'Open a case' ); return fail( c, 'A photo could not be uploaded. Please try again.' ); }
				return post( '/order-problem', { submission_id: rid(), order: order.number, problem: k, fields: fields, photo_ids: ids } ).then( function ( r ) {
					if ( ! r.ok ) { c.remove(); return orderFail( r.data && r.data.code ); }
					c.remove();
					showTyping();
					S.caseWait = { order: order, problem: problem, since: Date.now() };
				} );
			} );
		} );
	}
	function caseDone( caseId ) {
		var w = S.caseWait; S.caseWait = null;
		hideTyping();
		if ( caseId && w ) {
			breakRun();
			add( el( 'fcw-card', '<h3>Case ' + esc( caseId ) + ' opened</h3><div class="fcw-sum">' +
				'<div><span>Order</span><span>' + esc( w.order.number ) + '</span></div>' +
				'<div><span>Problem</span><span>' + esc( w.problem[ 1 ] ) + '</span></div>' +
				'<div><span>Reply to</span><span>' + esc( S.email ) + '</span></div></div>' ) );
		}
		var extra = w && w.problem[ 0 ] === 'return' ? ' The prepaid DHL label comes with that reply.' : '';
		note( 'wait', '<b>The team has your case.</b><br>A colleague replies by email within 1 to 3 business days.' + extra + ' Nothing more is needed from you now.' );
		S.hoSent = true; renderStatus();
	}

	/* ---------- Kai text rendering ---------- */
	// Decode stored entities, escape, drop markdown bold/bullets, linkify, turn action tokens into links.
	function fcRender( text ) {
		var ta = document.createElement( 'textarea' ); ta.innerHTML = text || ''; var t = ta.value;
		t = t.replace( /\*\*(.+?)\*\*/g, '$1' ).replace( /^[ \t]*[-*]\s+/gm, '' );
		var h = esc( t ).replace( /&#39;/g, "'" );
		h = h.replace( /(https?:\/\/[^\s<"]+)/g, '<a href="$1" target="_blank" rel="noopener">$1</a>' );
		h = h.replace( /\[\[REQUEST_CABLE\]\]/g, '<a href="#" class="fcw-act" data-act="cable">request a cable</a>' );
		h = h.replace( /\[\[NEWSLETTER\]\]/g, '<a href="#" class="fcw-act" data-act="newsletter">subscribe to our newsletter</a>' );
		h = h.replace( /\[\[REQUEST_QUOTE\]\]/g, '<a href="#" class="fcw-act" data-act="quote">request a quote</a>' );
		h = h.replace( /\[\[REQUEST_SPECIALIST\]\]/g, '<a href="#" class="fcw-act" data-act="specialist">request a specialist</a>' );
		h = h.replace( /\[\[VERIFY_EMAIL\]\]/g, '<a href="#" class="fcw-act" data-act="verify">verify your email</a>' );
		h = h.replace( /\[\[RESTOCK\]\]/g, productHandle() ? '<a href="#" class="fcw-act" data-act="restock">get one email when it is back</a>' : 'ask us later' );
		h = h.replace( /\[\[HANDOFF_FORM\]\]/g, '' ).replace( /\[\[JOINED\]\]/g, '' );
		return h;
	}
	log.addEventListener( 'click', function ( e ) {
		var a = e.target && e.target.closest ? e.target.closest( '.fcw-act' ) : null;
		if ( ! a ) { return; }
		e.preventDefault();
		var act = a.getAttribute( 'data-act' );
		if ( act === 'newsletter' ) { showNewsletter(); }
		else if ( act === 'specialist' ) { showHandoff(); }
		else if ( act === 'quote' ) { showQuote(); }
		else if ( act === 'verify' ) { showVerify(); }
		else if ( act === 'restock' ) { loadProduct().then( function ( p ) { if ( p ) { showStock(); } } ); }
		else { showCable(); }
	} );

	/* ---------- quick replies (fresh chat only) ---------- */
	function quick( list ) {
		quickEl.innerHTML = '';
		( list || [] ).forEach( function ( x ) {
			var b = document.createElement( 'button' );
			b.type = 'button'; b.textContent = x[ 0 ];
			b.addEventListener( 'click', function () { quickEl.innerHTML = ''; x[ 1 ](); } );
			quickEl.appendChild( b );
		} );
	}
	function sendText( text ) { input.value = text; send(); }

	function greet() {
		botMsg( 'Hi, I am Kai, Falconclaw\'s assistant. Ask me anything about our gear. ' +
			( orderFlowOn() ? 'For a problem with an order I open a case for the team. ' : '' ) +
			'You can always ask for a person, they reply within 1 to 3 business days.', null, true );
		quick( [
			[ 'Problem with an order', function () { if ( orderFlowOn() ) { startOrderFlow(); } else { sendText( 'I have a problem with an order' ); } } ],
			[ 'Talk to a person', showHandoff ],
			[ 'Which cable fits my radio?', function () { sendText( 'Which cable fits my radio?' ); } ]
		] );
	}

	/* ---------- open / close ---------- */
	function openPanel() {
		panel.hidden = false;
		toggle.hidden = true;
		toggle.setAttribute( 'aria-expanded', 'true' );
		detectCaps().then( function () {
			if ( ! started ) { started = true; greet(); }
		} );
		loadProduct();
		setTimeout( function () { try { input.focus( { preventScroll: true } ); } catch ( e ) { input.focus(); } }, 30 );
		scrollDown();
	}
	function closePanel() {
		var inside = panel.contains( document.activeElement );
		panel.hidden = true;
		toggle.hidden = false;
		toggle.setAttribute( 'aria-expanded', 'false' );
		if ( inside ) { toggle.focus(); }
	}
	toggle.addEventListener( 'click', openPanel );
	$( '#fc-chat-close' ).addEventListener( 'click', closePanel );
	panel.addEventListener( 'keydown', function ( e ) { if ( e.key === 'Escape' ) { closePanel(); } } );

	/* ---------- composer ---------- */
	function grow() {
		input.style.height = '';
		var full = false;
		if ( input.value ) {
			var h = input.scrollHeight + 2;
			full = h > 130;
			input.style.height = Math.min( h, 130 ) + 'px';
		}
		input.classList.toggle( 'is-full', full );
	}
	input.addEventListener( 'input', grow );
	input.addEventListener( 'keydown', function ( e ) {
		if ( e.key === 'Enter' && ! e.shiftKey && ! e.isComposing ) { e.preventDefault(); send(); }
	} );
	form.addEventListener( 'submit', function ( e ) { e.preventDefault(); send(); } );

	function send() {
		var text = ( input.value || '' ).trim();
		if ( ! text ) { return; }
		input.value = ''; grow();
		quickEl.innerHTML = '';
		if ( lastStatus === 'closed' ) {   // a closed chat restarts as a fresh AI chat
			dropConversation();
			sys( 'New chat' );
		}
		var tick = customerMsg( text );
		lastTick = tick;
		customerAsked = true;
		feedbackOnCustomerMsg( text );
		var rate = document.getElementById( 'fcw-rate' ); if ( rate ) { rate.remove(); }
		if ( lastStatus !== 'human' ) { pendingSince = Date.now(); showTyping(); }   // dots at once, not on bot_typing
		S.askedStock = STOCK_RE.test( text );
		if ( S.hoSkipped && PERSON_RE.test( text ) ) { showHandoff(); }
		ensureConv().then( function ( ok ) {
			if ( ! ok ) { return { ok: false }; }
			return post( '/message', { text: text } );
		} ).then( function ( r ) {
			if ( r.ok ) { setTick( tick, 'sent' ); return; }
			pendingSince = 0; hideTyping();
			sys( 'Your message could not be sent. Check your connection and try again.' );
			if ( ! input.value ) { input.value = text; grow(); }
		} );
	}

	/* ---------- poll ---------- */
	function poll() {
		if ( polling || ! convId || pollStopped ) { return; }
		polling = true;
		api( '/poll?' + authQuery() + '&after_id=' + afterId ).then( function ( r ) {
			if ( r.status === 403 || r.status === 404 ) {   // conversation gone: stop, next message starts fresh
				pollStopped = true; hideTyping(); dropConversation();
				return;
			}
			if ( ! r.ok ) { return; }
			var d = r.data, msgs = d.messages || [], gotBot = false, gotAny = false;
			msgs.forEach( function ( m ) {
				var body = m.body || '', wantForm = false;
				if ( m.sender === 'agent' && /\[\[JOINED\]\]/.test( body ) ) {
					agentName = m.agent_name || agentName;
					sys( ( m.agent_name || 'A colleague' ) + ' has joined the chat' );
				} else {
					if ( /\[\[HANDOFF_FORM\]\]/.test( body ) ) { wantForm = true; body = body.replace( /\[\[HANDOFF_FORM\]\]/g, '' ).trim(); }
					if ( m.sender === 'agent' ) { agentName = m.agent_name || agentName; agentMsg( m.agent_name || 'Falconclaw', body ); }
					else { botMsg( body, m.id ); botReplied = true; gotBot = true; }
					gotAny = true;
					if ( wantForm && ! S.hoSent ) { showHandoff(); }
				}
				var id = parseInt( m.id, 10 );
				if ( id > afterId ) { afterId = id; }
			} );
			if ( msgs.length && lastTick ) { setTick( lastTick, 'read' ); }
			if ( gotAny ) { pendingSince = 0; }
			if ( d.bot_typing && ! msgs.length ) {
				if ( lastTick ) { setTick( lastTick, 'read' ); }
				showTyping();
			} else if ( ! gotAny && pendingSince && Date.now() - pendingSince < TYPING_GRACE_MS && d.status !== 'human' ) {
				showTyping();
			} else if ( ! S.caseWait ) {
				pendingSince = 0; hideTyping( gotAny );
			}
			if ( d.status === 'closed' && lastStatus !== 'closed' ) { sys( 'Chat closed. Send a message to start a new one.' ); }
			lastStatus = d.status || null;
			renderStatus();
			if ( gotBot ) { armFeedback(); }
			if ( gotBot && S.askedStock && ! S.stockOffered ) {
				S.askedStock = false;
				loadProduct().then( function ( p ) { var v = currentVariant(); if ( p && v && ! v.available ) { showStock(); } } );
			}
			if ( S.caseWait ) {
				var cid = d.intake && d.intake.case_id;
				if ( cid ) { caseDone( cid ); }
				else if ( Date.now() - S.caseWait.since > 30000 ) { caseDone( '' ); }
			}
		} ).then( function () {
			polling = false;
			if ( ! pollStopped && convId ) { setTimeout( poll, pendingSince ? PENDING_POLL_MS : POLL_MS ); }
		} );
	}

	/* ---------- resume a returning visitor's chat ---------- */
	function renderHistMsg( m ) {
		var body = m.body || '';
		if ( m.sender === 'customer' ) {
			// Old-widget form lines are shown as what they were, not as raw text.
			if ( body.indexOf( '📋' ) === 0 ) { S.hoSent = true; sys( 'Contact details sent to the team' ); }
			else if ( body.indexOf( '🧾' ) === 0 ) { S.hoSent = true; sys( 'Quote request sent' ); }
			else if ( /^CABLE REQUEST/.test( body ) ) { sys( 'Cable request sent' ); }
			else { setTick( customerMsg( body ), 'read' ); }
			customerAsked = true;
			return;
		}
		if ( m.sender === 'agent' && /\[\[JOINED\]\]/.test( body ) ) {
			agentName = m.agent_name || agentName;
			sys( ( m.agent_name || 'A colleague' ) + ' has joined the chat' );
			return;
		}
		body = body.replace( /\[\[HANDOFF_FORM\]\]/g, '' ).trim();
		if ( m.sender === 'agent' ) { agentName = m.agent_name || agentName; agentMsg( m.agent_name || 'Falconclaw', body ); }
		else { botMsg( body, m.id ); botReplied = true; }
	}
	function resume() {
		var cid, tok;
		try { cid = localStorage.getItem( 'fc_chat_cid' ); tok = localStorage.getItem( 'fc_chat_tok' ); } catch ( e ) {}
		if ( ! cid || ! tok ) { return; }
		detectCaps().then( function () {
			return api( '/history?conversation_id=' + encodeURIComponent( cid ) + '&customer_token=' + encodeURIComponent( tok ) );
		} ).then( function ( r ) {
			var d = r.data;
			if ( ! r.ok || ! d || ! d.messages || ! d.messages.length ) {
				if ( r.status !== 0 ) { clearSession(); }   // keep it on a network blip
				return;
			}
			convId = cid; custTok = tok; started = true; lastStatus = d.status || null;
			if ( d.rating ) { fbRated = true; }
			sys( 'Earlier in this chat' );
			d.messages.forEach( function ( m ) {
				renderHistMsg( m );
				var id = parseInt( m.id, 10 ); if ( id > afterId ) { afterId = id; }
			} );
			renderStatus();
			armFeedback();
			poll();
		} );
	}

	resume();
} )();

/* Newsletter prefill (restock confirmation P.S. link, 2026-07-10): when the URL has
   ?nl=<email>, pre-fill the footer newsletter form and bring it into view. */
( function () {
	try {
		var m = location.search.match( /[?&]nl=([^&]+)/ );
		if ( ! m ) { return; }
		var email = decodeURIComponent( m[1] );
		var arm = function () {
			var inp = document.querySelector( 'footer input[type="email"], input[name="contact[email]"]' );
			if ( ! inp ) { return false; }
			inp.value = email;
			try { inp.dispatchEvent( new Event( 'input', { bubbles: true } ) ); } catch ( e ) {}
			setTimeout( function () { inp.scrollIntoView( { behavior: "smooth", block: "center" } ); inp.focus(); }, 400 );
			return true;
		};
		if ( document.readyState === "loading" ) {
			document.addEventListener( "DOMContentLoaded", arm );
		} else if ( ! arm() ) {
			setTimeout( arm, 1200 );
		}
	} catch ( e ) {}
} )();
